export const FETCH_ORDERS_BY_STATUS_SUCCESS = "FETCH_ORDERS_BY_STATUS_SUCCESS";
export const FETCH_ORDERS_BY_STATUS_REQUEST = "FETCH_ORDERS_BY_STATUS_REQUEST";
export const FETCH_ORDERS_BY_STATUS_FAILURE = "FETCH_ORDERS_BY_STATUS_FAILURE";
export const FETCH_ORDERS_BY_STATUS_RESET = "FETCH_ORDERS_BY_STATUS_RESET";
export const fetchOrdersByStatusSuccess = (payload) => ({
    type: FETCH_ORDERS_BY_STATUS_SUCCESS,
    payload,
});
export const fetchOrdersByStatusRequest = (payload) => ({
    type: FETCH_ORDERS_BY_STATUS_REQUEST,
    payload,
});
export const fetchOrdersByStatusFailure = (payload) => ({
    type: FETCH_ORDERS_BY_STATUS_FAILURE,
    payload,
});
export const fetchOrdersByStatusReset = () => ({
    type: FETCH_ORDERS_BY_STATUS_RESET,
});
